(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/win-anim.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/win-anim.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const drawWinAnim = svs.bingo_react.components.bingoCard.canvas.drawWinAnim;

const ANIM_TOTAL_TIME = 4.0 * 1000.0;
const WinAnim = _ref => {
  let _ref$lastWinTimestamp = _ref.lastWinTimestamp,
    lastWinTimestamp = _ref$lastWinTimestamp === void 0 ? 0 : _ref$lastWinTimestamp;
  const canvasRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    if (!canvasRef.current) {
      return;
    }
    if (!lastWinTimestamp) {
      return;
    }
    if (new Date().getTime() - lastWinTimestamp > 7500) {
      return;
    }
    setIsVisible(true);
    let animationFrameId;
    const startTime = document.timeline.currentTime;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const render = timestamp => {
      const _canvas$getBoundingCl = canvas.getBoundingClientRect(),
        width = _canvas$getBoundingCl.width,
        height = _canvas$getBoundingCl.height;
      const _window = window,
        devicePixelRatio = _window.devicePixelRatio;
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width * devicePixelRatio;
        canvas.height = height * devicePixelRatio;
      }
      const elapsedTime = timestamp - startTime;
      const progress = Math.max(Math.min(elapsedTime / ANIM_TOTAL_TIME, 1.0), 0.0);
      drawWinAnim(context, progress, ANIM_TOTAL_TIME);
      if (progress >= 1.0) {
        setIsVisible(false);
      } else {
        animationFrameId = window.requestAnimationFrame(render);
      }
    };
    animationFrameId = window.requestAnimationFrame(render);
    return () => {
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [lastWinTimestamp]);
  const classNames = ['bingo-card-win-anim'];
  if (!isVisible) {
    classNames.push('hide');
  }
  return React.createElement("canvas", {
    className: classNames.join(' '),
    ref: canvasRef
  });
};
setGlobal('svs.bingo_react.components.bingoCard.WinAnim', WinAnim);

 })(window);